import React, {Fragment, useEffect, useState} from "react";
import Cookies from 'js-cookie';
import {useSearchParams} from "react-router-dom";
import ErrorPage from "../pages/payment/misa/ErrorPage";
import Http from "../HttpOnly";
import {BankHubUrl} from "../config/BankhubUrl";
import BankHubLog from "../config/BankHubLog";

const Auth = ({children}) => {
    const [isError, setIsError] = useState(false)
    let [searchParams, setSearchParams] = useSearchParams();
    // useEffect(() => {
    //     if(!Cookies.get('Authorization') || Cookies.get('Authorization') === undefined) {
    //         window.postMessage({ type: 'eventCallBackVerifyTransaction', result: {
    //                 code: 'BH001-000005',
    //                 msg: BankHubLog['BH001-000005']
    //             } }, process.env.REACT_APP_KHDN_DMG_URL);
    //         setIsError(true)
    //     }
    // }, [])

    return (
        <Fragment>
            { isError ? <ErrorPage/> : children}
        </Fragment>
    )
}

export default Auth
